import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import service from '../../../apis/service';
import { apiEndpoints } from '../../../constants/apiEndpoints';
import { ErrorToast } from '../../utils/Utils';
import { showProgress } from '../../../redux/actions/DealershipActions';

const cleanFilters = (filters = {}) => {
  const cleaned = {};
  Object.entries(filters).forEach(([k, v]) => {
    if (v === null || v === undefined || v === '') return;
    if (Array.isArray(v) && v.length === 0) return;
    cleaned[k] = v;
  });
  return cleaned;
};

const useFetchDealershipList = () => {
  const dispatch = useDispatch();
  const [dealershipList, setDealershipList] = useState([]);
  const [rowCount, setRowCount] = useState(0);

  const getList = useCallback(
    async (pagination = null, sorting = null, filters = {}) => {
      const sort = sorting ? sorting[0] : null;
      const cleanedFilters = cleanFilters(filters);

      const payload = {
        page: (pagination?.pageIndex ?? 0) + 1,
        limit: pagination?.pageSize ?? 20,
      };

      if (sort?.id) {
        payload.sortBy = sort.id;
        payload.sortOrder = sort.desc ? 'DESC' : 'ASC';
      }
      if (Object.keys(cleanedFilters).length > 0) {
        payload.filters = cleanedFilters;
      }

      dispatch(showProgress(true));
      try {
        const response = await service.post(apiEndpoints.DEALERSHIP_DETAIL_LIST, payload);
        setDealershipList(response?.data ?? []);
        setRowCount(response?.pagination?.total ?? 0);
      } catch (error) {
        ErrorToast(error);
      } finally {
        dispatch(showProgress(false));
      }
    },
    [dispatch],
  );

  return { dealershipList, rowCount, getList };
};

export default useFetchDealershipList;
